import React, { useState } from "react";
import { useInView } from "react-intersection-observer";
import { NavbarContext } from "../context";
import { contactInfo } from "../data/portfolioData";
import { scrollToSection } from "../utils/scrollToSection";

const NAV_ITEMS = [
  { id: "home", label: "Home" },
  { id: "projects", label: "Results" },
  { id: "process", label: "How I work" },
  { id: "experience", label: "Experience" },
  { id: "about", label: "About" },
  { id: "contact", label: "Contact" },
];

export const Navbar = ({ children }) => {
  const [active, setActive] = useState("home");
  const [mobileOpen, setMobileOpen] = useState(false);
  // A sentinel at the top of the page tells us when the user has scrolled, without a scroll listener.
  const { ref: topSentinelRef, inView: atTop } = useInView({ initialInView: true });

  const scrollTo = (id) => {
    scrollToSection(`${id}-page`);
    setMobileOpen(false);
  };

  return (
    <>
      <div ref={topSentinelRef} className="nav-top-sentinel" aria-hidden="true" />

      <header
        id="site-nav"
        className={`portfolio-nav${atTop ? "" : " scrolled"}`}
      >
        <a
          href="#home-page"
          className="nav-brand"
          aria-label="Lê Mạnh Hùng, back to top"
          onClick={(e) => { e.preventDefault(); scrollTo("home"); }}
        >
          LMH
        </a>

        <nav aria-label="Main navigation">
          <ul className="nav-links">
            {NAV_ITEMS.map(({ id, label }) => (
              <li key={id}>
                <button
                  type="button"
                  id={`nav-${id}`}
                  className={active === id ? "active" : ""}
                  onClick={() => scrollTo(id)}
                  aria-current={active === id ? "true" : undefined}
                >
                  {label}
                </button>
              </li>
            ))}
            <li>
              <a
                href={`mailto:${contactInfo.email}`}
                className="nav-cta-link"
                id="nav-email-cta"
              >
                Email me
              </a>
            </li>
          </ul>
        </nav>

        <button
          type="button"
          className="nav-hamburger"
          onClick={() => setMobileOpen((open) => !open)}
          aria-expanded={mobileOpen}
          aria-controls="mobile-nav"
          aria-label={mobileOpen ? "Close menu" : "Open menu"}
        >
          <span />
          <span />
          <span />
        </button>
      </header>

      <nav
        id="mobile-nav"
        className={`nav-mobile${mobileOpen ? " open" : ""}`}
        aria-label="Mobile navigation"
        hidden={!mobileOpen}
      >
        {NAV_ITEMS.map(({ id, label }) => (
          <button type="button" key={id} onClick={() => scrollTo(id)}>
            {label}
          </button>
        ))}
        <a href={`mailto:${contactInfo.email}`}>Email me</a>
      </nav>

      <NavbarContext.Provider value={setActive}>
        {children}
      </NavbarContext.Provider>
    </>
  );
};
